var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup76(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 145,
    viewBox: "0 0 75 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 45,
    height: 145,
    fill: "#E7FFEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9301 83.3157C29.2092 82.9244 29.7908 82.9244 30.0699 83.3157L37.2217 93.3435C37.5522 93.8069 37.2209 94.45 36.6518 94.45H22.3482C21.7791 94.45 21.4478 93.8069 21.7783 93.3435L28.9301 83.3157Z",
    fill: "#31BF5C",
    stroke: "#26A54C",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 50.3,
    width: 57.4,
    height: 37.4,
    rx: 2.7,
    fill: "#31BF5C",
    stroke: "#26A54C",
    strokeWidth: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.3,
    y: 53.3,
    width: 51.4,
    height: 31.4,
    rx: 1.7,
    fill: "white",
    stroke: "#26A54C",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup76);
export default __webpack_public_path__ + "static/media/Group 76.bdabaf8629c0c8f239762c42a615f372.svg";
export { ForwardRef as ReactComponent };